import "./user-limit-settings.scss";

const keyToTitleMapper = {
  maxRegisteredDevices: "Maximum number of devices registration",
  maxRegisteredDevicesTimeWindow: "Number of days",
  maxLoginsPerDevice: "Maximum logins allowed per device",
  maxLoginsPerDeviceTimeWindow: "Number of days",
  maxScanCount: "Total Scan Count",
  maxScanCountTimeWindow: "Minutes",
};

export default function UserLimitCardList(props) {
  const { userSettings } = props;

  return (
    <div>
      <div className="user-limit-cards-container">
        <div className="user-limit-card">
          <h4>User Device Limit Settings</h4>
          <p className="description">
            A user can login/register on maximum X devices in last Y days.
          </p>
          <div className="values-container">
            <h5>
              {keyToTitleMapper["maxRegisteredDevices"]}:
              <span>{userSettings["maxRegisteredDevices"]}</span>
            </h5>
            <h5>
              {keyToTitleMapper["maxRegisteredDevicesTimeWindow"]}:
              <span>{userSettings["maxRegisteredDevicesTimeWindow"]}</span>
            </h5>
          </div>
        </div>
        <div className="user-limit-card">
          <h4>User Login Limit Settings</h4>
          <p className="description">
            On one device, a maximum of X logins/registrations can happen in the last
            Y days.
          </p>
          <div className="values-container">
            <h5>
              {keyToTitleMapper["maxLoginsPerDevice"]} :
              <span>{userSettings["maxLoginsPerDevice"]}</span>
            </h5>
            <h5>
              {keyToTitleMapper["maxLoginsPerDeviceTimeWindow"]}:
              <span>{userSettings["maxLoginsPerDeviceTimeWindow"]}</span>
            </h5>
          </div>
        </div>
        <div className="user-limit-card">
          <h4>User Successful Code Scan Limit Settings</h4>
          <p className="description">
            Maximum number of X code scans are allowed per user account in Y minutes.
          </p>
          <div className="values-container">
            <h5>
              {keyToTitleMapper["maxScanCount"]}:
              <span>{userSettings["maxScanCount"]}</span>
            </h5>
            <h5>
              {keyToTitleMapper["maxScanCountTimeWindow"]}:
              <span>{userSettings["maxScanCountTimeWindow"]}</span>
            </h5>
          </div>
        </div>
      </div>
    </div>
  );
}
